/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type TimeBasedChartFragment = {|
  +today: ?number;
  +yesterday: ?number;
  +pastWeek: ?number;
  +pastMonth: ?number;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeBasedChartFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "today",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "yesterday",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "pastWeek",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "pastMonth",
      "storageKey": null
    }
  ],
  "type": "MetricTimePeriod"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/home/__generated__/TimeBasedChartFragment.graphql.js